import styled from "@emotion/styled";
import { fontFredoka } from "@product/scmp-sdk";

import { Button } from "scmp-app/components/posties/button";
import { ZIndexLayer } from "scmp-app/lib/styles";

export const BackDrop = styled.div`
  position: fixed;
  z-index: ${ZIndexLayer.AlertBox - 1};

  inline-size: 100%;
  block-size: 100%;
`;

export const Container = styled.div`
  position: fixed;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  z-index: ${ZIndexLayer.AlertBox};

  inline-size: 100%;
  max-inline-size: 663px;
  padding-block: 54px 38px;

  background-color: #ffffff;

  transform: translate(-50%, -50%);
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Message = styled.div`
  max-inline-size: 343px;
  margin-block: 24px;

  font-size: 16px;
  line-height: 22.4px;
  text-align: center;
`;

export const StyledBackButton = styled(Button)``;

export const CloseButton = styled.div`
  margin-block-start: 8px;

  font-weight: 600;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 20px;
  letter-spacing: 0.03em;

  text-decoration-line: underline;

  cursor: pointer;
`;
